import create from 'zustand';
import createStoreSelectors from './utils/createStoreSelector';

const useStore = create((set) => ({
  isReferralSuccessful: false,
  isReferralCodeApplied: false,
  setIsReferralSuccessful: (value) => {
    set((state) => ({
      ...state,
      isReferralSuccessful: value
    }));
  },
  setIsReferralCodeApplied: (value) => {
    set((state) => ({
      ...state,
      isReferralCodeApplied: value
    }));
  }
}));

const useReferralCodeStatusStore = createStoreSelectors(useStore);

export default useReferralCodeStatusStore;
